import Vue from 'vue';

export default class TenderSorting {
    private elem: HTMLElement;

    static factory(): void {
        document.querySelectorAll('[data-tendersorting]').forEach((elem: HTMLElement) => {
            new TenderSorting(elem);
        });
    }

    constructor(elem: HTMLElement) {
        this.elem = elem;

        this.initTenderSorting();
    }

    private initTenderSorting() {
        new Vue({
            el: this.elem,
            data: {
                    selected: 'tender_region',
                    itemOrder: [
                        {id: 1, name: 'Product type ascending', value: 'tender_main_product_type'},
                        {id: 2, name: 'Product type descending', value: 'tender_main_product_type:desc'},
                        {id: 3, name: 'Region ascending', value: 'tender_region'},
                        {id: 4, name: 'Region descending', value: 'tender_region:desc'},
                    ]
            },
            components: {

            },
            mounted: function() {
                const url = new URL(window.location);
                const tender_order =  url.searchParams.get('tender_order', this.selected);
                this.selected = tender_order;
            },
            methods: {
                sortingtenders() {
                    const url = new URL(window.location);
                    url.searchParams.set('tender_order', this.selected);
                    window.history.pushState({}, '', url);
                    window.location.reload(true);
                },

            }
        })
    }

}